var map = {
	"./Auth/ConfirmPassword.vue": 4970,
	"./Auth/ForgotPassword.vue": 9162,
	"./Auth/ForgotPasswordNewPassword.vue": 4796,
	"./Auth/ForgotPasswordVerification.vue": 2255,
	"./Auth/Login.vue": 6988,
	"./Auth/RegisterApelido.vue": 1990,
	"./Auth/ResetPassword.vue": 1320,
	"./Auth/VerifyEmail.vue": 9731,
	"./Auth/Welcome.vue": 1673,
	"./CampaignsWall.vue": 9924,
	"./ContactAuth.vue": 2746,
	"./ContactAuthForm.vue": 5464,
	"./ContactAuthFormSugest.vue": 2466,
	"./ContactForm.vue": 2315,
	"./ContactFormSugest.vue": 3309,
	"./ContactGuest.vue": 1234,
	"./Dashboard.vue": 1618,
	"./DesignSystem/Components.vue": 7909,
	"./ExtratoPontos.vue": 2861,
	"./Faq.vue": 4958,
	"./FaqAuth.vue": 7251,
	"./ForcedPasswordChange/Index.vue": 6691,
	"./Gallery.vue": 4008,
	"./HomeDeslogado.vue": 6022,
	"./HowItWorks.vue": 9757,
	"./Mechanics.vue": 505,
	"./MyProfile.vue": 6305,
	"./MyProfile/MFA/index.vue": 3452,
	"./MyProfileBlock/index.vue": 9892,
	"./News.vue": 7824,
	"./News/Detail.vue": 3634,
	"./News/List.vue": 937,
	"./NewsDetails.vue": 3083,
	"./Performance.vue": 531,
	"./PhotosVoting/Historic/Index.vue": 1761,
	"./PhotosVoting/Index.vue": 5609,
	"./PhotosVoting/Voting.vue": 6477,
	"./PrivacyAuth.vue": 3480,
	"./PrivacyComponent.vue": 506,
	"./PrivacyGuest.vue": 9909,
	"./Profile.vue": 2287,
	"./Profile/PushNotificationCodes.vue": 4420,
	"./ProfileChangePassword/CurrentPassword.vue": 3662,
	"./ProfileChangePassword/NewPassword.vue": 2167,
	"./Qualifiers.vue": 3713,
	"./Ranking.vue": 1504,
	"./Register/Apelido.vue": 1603,
	"./Register/Email.vue": 8666,
	"./Register/Idade.vue": 2992,
	"./Register/Index.vue": 8350,
	"./Register/MFACreate.vue": 2133,
	"./Register/MFAValidate.vue": 4624,
	"./Register/NomeDeUsuario.vue": 3010,
	"./Register/PrimeiroNome.vue": 6599,
	"./Register/Privacy.vue": 352,
	"./Register/RegisterParticipante.vue": 3699,
	"./Register/RegisterSuccess.vue": 4538,
	"./Register/Regulamento.vue": 4843,
	"./Register/SegundoNome.vue": 3925,
	"./Register/Senha.vue": 7661,
	"./Register/Transparencia.vue": 6426,
	"./Register/VerifyEmail.vue": 2724,
	"./RegulamentoAuth.vue": 7286,
	"./Rules.vue": 652,
	"./Score.vue": 1139,
	"./Shelfpix/Monitor.vue": 8721,
	"./TeamPerformance.vue": 5431,
	"./Terms.vue": 3433,
	"./TermsAuth.vue": 9821,
	"./Training/Detail.vue": 1879,
	"./Training/List.vue": 7678,
	"./Training/Quiz.vue": 4897,
	"./UploadPhotos/index.vue": 2964,
	"./WallCampaign.vue": 667,
	"./Winners.vue": 2577
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1230;